module.exports = __webpack_public_path__ + "static/media/PD_productdetails.8185afee.png";